<p>
  setting-view-user works!
</p>
